import { Component } from '@angular/core';

@Component({
  selector: 'app-footer-buttons-spacer',
  templateUrl: './footer-buttons-spacer.component.html',
  styleUrls: ['./footer-buttons-spacer.component.scss'],
})
export class FooterButtonsSpacerComponent { }
